import TabPage from './tab-page'
export default TabPage
